module.exports = __webpack_public_path__ + "img/qrcode1.c188733e.jpg";